import React, { useState } from "react";
import Task from "./Task";
import CurrentSituation from "./Forms/CurrentSituation";
import IdeaBank from "./Forms/IdeaBank";
import ActionPlan from "./Forms/ActionPlan";
import Implementation from "./Forms/Implementation";
import Evaluation from "./Forms/Evaluation";
import { Droppable } from "react-beautiful-dnd";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import useExitPrompt from "../utils/useExitPrompt";
import { Link, Prompt } from "react-router-dom";
import PromptBox from "./PromptBox";

const Column = (props) => {
  const [translation] = useTranslation("translations");
  const [show, setShow] = useState(false);
  const [showArchived, setShowArchived] = useState(false);
  const [showExitPrompt, setShowExitPrompt] = useExitPrompt(false);
  const [displayPrompt, setDisplayPrompt] = useState(false);
  const handleClosePrompt = () => {
    setShow(false);
    setShowExitPrompt(false);
    setDisplayPrompt(false);
  };
  const handleClose = (close = false) => {
    setShow(false);
  };
  const handleShow = () => setShow(true);
  const addTaskForm = () => {
    switch (props.columnNo) {
      case 1:
        return (
          <CurrentSituation
            show={show}
            handleClose={handleClose}
            board={props?.board}
            columnId={props?.columnId}
            addTask={props?.addTask}
            config={props?.config}
            handleDelete={props.handleDelete}
            columnTitle={props.column.title}
            setShowCloseConfirmation={(val) => {
              setShowExitPrompt(val);
            }}
            resetInitially={true}
          />
        );
      case 2:
        return (
          <IdeaBank
            show={show}
            handleClose={handleClose}
            board={props?.board}
            columnId={props?.columnId}
            addTask={props?.addTask}
            config={props?.config}
            handleDelete={props.handleDelete}
            columnTitle={props.column.title}
            setShowCloseConfirmation={(val) => {
              setShowExitPrompt(val);
            }}
            resetInitially={true}
          />
        );
      case 3:
        return (
          <ActionPlan
            show={show}
            handleClose={handleClose}
            board={props?.board}
            columnId={props?.columnId}
            addTask={props?.addTask}
            config={props?.config}
            handleDelete={props.handleDelete}
            columnTitle={props.column.title}
            setShowCloseConfirmation={(val) => {
              setShowExitPrompt(val);
            }}
            resetInitially={true}
          />
        );
      case 4:
        return (
          <Implementation
            show={show}
            handleClose={handleClose}
            board={props?.board}
            columnId={props?.columnId}
            addTask={props?.addTask}
            config={props?.config}
            handleDelete={props.handleDelete}
            columnTitle={props.column.title}
            setShowCloseConfirmation={(val) => {
              setShowExitPrompt(val);
            }}
            resetInitially={true}
          />
        );
      case 5:
        return (
          <Evaluation
            show={show}
            handleClose={handleClose}
            board={props?.board}
            columnId={props?.columnId}
            addTask={props?.addTask}
            config={props?.config}
            handleDelete={props.handleDelete}
            columnTitle={props.column.title}
            setShowCloseConfirmation={(val) => {
              setShowExitPrompt(val);
            }}
            resetInitially={true}
          />
        );
      default:
        return "";
    }
  };

  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <Link
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      {/* Render custom icon here */}
      <i className="fa fa-ellipsis-v grey-color" aria-hidden="true"></i>
      {children}
    </Link>
  ));

  return (
    <div>
      <Prompt
        when={showExitPrompt}
        message={translation("form_close_confirmation")}
      />
      <Droppable droppableId={`${props.column.id}`}>
        {(provided, snapshot) => (
          <div
            className="column-wraper"
            {...provided.droppableProps}
            ref={provided.innerRef}
          >
            <div style={{ width: "260px" }}>
              <div className="row d-flex align-items-center">
                <div className="col-10">
                  <h5 className="d-flex  align-items-center">
                    <div
                      style={{
                        width: "35px",
                        height: "35px",
                        marginRight: "10px",
                      }}
                      className={`d-flex align-items-center justify-content-center ${
                        props.columnNo === 1
                          ? "bg-sea-green"
                          : props.columnNo === 2
                          ? "bg-light-red"
                          : props.columnNo === 3
                          ? "bg-action-blue"
                          : props.columnNo === 4
                          ? "bg-light-green"
                          : "bg-sustaingul"
                      } rounded-circle text-white font-weight-bold`}
                    >
                      {props.columnNo}
                    </div>
                    {props.column.title}
                  </h5>
                </div>
                <div className="col-sm-1 col-1 p-0">
                  <button onClick={handleShow} className="btn btn-link px-0">
                    <i className="fa fa-plus grey-color"></i>
                  </button>
                </div>
                <div className="col-sm-1 col-1 p-0">
                  <Dropdown>
                    <Dropdown.Toggle
                      as={CustomToggle}
                      align="end"
                      id="dropdown-basic"
                    />
                    <Dropdown.Menu className="border-1">
                      <Dropdown.Item
                        onClick={() => {
                          setShowArchived(!showArchived);
                        }}
                      >
                        {showArchived
                          ? translation("archived_cards.hide_archive")
                          : translation("archived_cards.show_archive")}
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
              {!showArchived && (
                <div>
                  <div
                    style={{
                      overflow: "auto",
                      height: `${window.innerHeight - 300}px`,
                    }}
                    className={`task-list p-1 mt-1  ${
                      snapshot.isDraggingOver
                        ? "bg-halite-blue"
                        : "bg-transparent"
                    }`}
                  >
                    {props.tasks.map((task, index) => (
                      <Task
                        key={task.id}
                        task={task}
                        index={index}
                        setSelectedTask={props.setSelectedTask}
                        setSelectedColumn={props.setSelectedColumn}
                        columnId={props.columnId}
                        openEditModel={() => {
                          props.openEditModel(task);
                        }}
                        showStatus={props.columnNo !== 2}
                      />
                    ))}
                  </div>
                  <div className="d-grid">
                    <button
                      onClick={handleShow}
                      className="btn btn-outline-gray btn-sm border-1 border"
                    >
                      {translation("buttons.add_new_task")}
                    </button>
                  </div>
                </div>
              )}

              <div className="d-flex justify-content-center"></div>
              {showArchived &&
                (props.archivedTasks?.length > 0 ? (
                  <div className="archive-card-container border-2 p-3 mb-3 rounded-3 bg-dark-grey">
                    <div className={`task-list p-1 mt-1`}>
                      <p>
                        <strong>{translation("archives")}</strong>
                      </p>
                      {showArchived &&
                        (props.archivedTasks?.length > 0 ? (
                          props.archivedTasks.map((task, index) => {
                            let status_color = task?.task_status?.name
                              ? task?.task_status?.name.toLowerCase()
                              : task?.task_status?.term_name
                              ? task?.task_status?.term_name.toLowerCase()
                              : task?.factor_description_type === "Minus"
                              ? "sy-red"
                              : task?.factor_description_type === "Plus"
                              ? "sy-green"
                              : "";
                            if (status_color === "grön") {
                              status_color = "sy-green";
                            } else if (status_color === "gul") {
                              status_color = "sy-yellow";
                            } else if (status_color === "röd") {
                              status_color = "sy-red";
                            }
                            return (
                              <div
                                style={{
                                  position: "relative",
                                  cursor: "pointer",
                                }}
                              >
                                <div
                                  className={`rounded task-wrap border-2 p-3 mb-3 single-task-item bg-white`}
                                  key={index}
                                  onClick={() => {
                                    props.setSelectedColumn(props.columnId);
                                    props.setSelectedTask(task);
                                    props.openEditModel(task);
                                  }}
                                >
                                  {task.title}
                                </div>

                                <div
                                  className={`position-absolute rounded-circle right-0 bg-${status_color}`}
                                  style={{
                                    width: "10px",
                                    height: "10px",
                                    marginRight: "10px",
                                    position: "absolute",
                                    top: "5px",
                                    right: 0,
                                    backgroundColor: status_color,
                                    borderRadius: "50%",
                                  }}
                                ></div>
                              </div>
                            );
                          })
                        ) : (
                          <div></div>
                        ))}
                    </div>
                  </div>
                ) : (
                  <div className="d-flex justify-content-center">
                    {translation("archived_cards.no_archive")}
                  </div>
                ))}
            </div>
            {provided.placeholder}
          </div>
        )}
      </Droppable>
      {addTaskForm()}

      <PromptBox
        show={displayPrompt}
        handleClosePrompt={handleClosePrompt}
        title={"here is the column"}
        message={"here is the column messages"}
        handleClose={() => setDisplayPrompt(false)}
        handleSave={() => {
          // console.log("save");
        }}
        isLoading={"false"}
      />
    </div>
  );
};

export default Column;
